export const formConstants = {
  alphabet: 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ',
  numbers: '0123456789',
  symbols: '!@#$%^&*()_+-=[]{}|;:,./ <>?',
  countries: [
    {
      code: 'af',
      name: 'afghanistan'
    },
    {
      code: 'al',
      name: 'albania'
    },
    {
      code: 'dz',
      name: 'algeria'
    },
    {
      code: 'as',
      name: 'american samoa'
    },
    {
      code: 'ad',
      name: 'andorra'
    },
    {
      code: 'ao',
      name: 'angola'
    },
    {
      code: 'ai',
      name: 'anguilla'
    },
    {
      code: 'aq',
      name: 'antarctica'
    },
    {
      code: 'ag',
      name: 'antigua and barbuda'
    },
    {
      code: 'ar',
      name: 'argentina'
    },
    {
      code: 'am',
      name: 'armenia'
    },
    {
      code: 'aw',
      name: 'aruba'
    },
    {
      code: 'au',
      name: 'australia'
    },
    {
      code: 'at',
      name: 'austria'
    },
    {
      code: 'az',
      name: 'azerbaijan'
    },
    {
      code: 'bs',
      name: 'bahamas'
    },
    {
      code: 'bh',
      name: 'bahrain'
    },
    {
      code: 'bd',
      name: 'bangladesh'
    },
    {
      code: 'bb',
      name: 'barbados'
    },
    {
      code: 'by',
      name: 'belarus'
    },
    {
      code: 'be',
      name: 'belgium'
    },
    {
      code: 'bz',
      name: 'belize'
    },
    {
      code: 'bj',
      name: 'benin'
    },
    {
      code: 'bm',
      name: 'bermuda'
    },
    {
      code: 'bt',
      name: 'bhutan'
    },
    {
      code: 'bo',
      name: 'bolivia, plurinational state of'
    },
    {
      code: 'ba',
      name: 'bosnia and herzegovina'
    },
    {
      code: 'bw',
      name: 'botswana'
    },
    {
      code: 'bv',
      name: 'bouvet island'
    },
    {
      code: 'br',
      name: 'brazil'
    },
    {
      code: 'io',
      name: 'british indian ocean territory'
    },
    {
      code: 'bn',
      name: 'brunei darussalam'
    },
    {
      code: 'bg',
      name: 'bulgaria'
    },
    {
      code: 'bf',
      name: 'burkina faso'
    },
    {
      code: 'bi',
      name: 'burundi'
    },
    {
      code: 'kh',
      name: 'cambodia'
    },
    {
      code: 'cm',
      name: 'cameroon'
    },
    {
      code: 'ca',
      name: 'canada'
    },
    {
      code: 'cv',
      name: 'cape verde'
    },
    {
      code: 'bq',
      name: 'caribbean netherlands'
    },
    {
      code: 'ky',
      name: 'cayman islands'
    },
    {
      code: 'cf',
      name: 'central african republic'
    },
    {
      code: 'td',
      name: 'chad'
    },
    {
      code: 'cl',
      name: 'chile'
    },
    {
      code: 'cn',
      name: "china (people's republic of china)"
    },
    {
      code: 'cx',
      name: 'christmas island'
    },
    {
      code: 'cc',
      name: 'cocos (keeling) islands'
    },
    {
      code: 'co',
      name: 'colombia'
    },
    {
      code: 'km',
      name: 'comoros'
    },
    {
      code: 'cd',
      name: 'congo, the democratic republic of the'
    },
    {
      code: 'ck',
      name: 'cook islands'
    },
    {
      code: 'cr',
      name: 'costa rica'
    },
    {
      code: 'hr',
      name: 'croatia'
    },
    {
      code: 'cu',
      name: 'cuba'
    },
    {
      code: 'cw',
      name: 'curaçao'
    },
    {
      code: 'cy',
      name: 'cyprus'
    },
    {
      code: 'cz',
      name: 'czech republic'
    },
    {
      code: 'ci',
      name: "côte d'ivoire"
    },
    {
      code: 'dk',
      name: 'denmark'
    },
    {
      code: 'dj',
      name: 'djibouti'
    },
    {
      code: 'dm',
      name: 'dominica'
    },
    {
      code: 'do',
      name: 'dominican republic'
    },
    {
      code: 'ec',
      name: 'ecuador'
    },
    {
      code: 'eg',
      name: 'egypt'
    },
    {
      code: 'sv',
      name: 'el salvador'
    },
    {
      code: 'gb-eng',
      name: 'england'
    },
    {
      code: 'gq',
      name: 'equatorial guinea'
    },
    {
      code: 'er',
      name: 'eritrea'
    },
    {
      code: 'ee',
      name: 'estonia'
    },
    {
      code: 'et',
      name: 'ethiopia'
    },
    {
      code: 'eu',
      name: 'europe'
    },
    {
      code: 'fk',
      name: 'falkland islands (malvinas)'
    },
    {
      code: 'fo',
      name: 'faroe islands'
    },
    {
      code: 'fj',
      name: 'fiji'
    },
    {
      code: 'fi',
      name: 'finland'
    },
    {
      code: 'fr',
      name: 'france'
    },
    {
      code: 'gf',
      name: 'french guiana'
    },
    {
      code: 'pf',
      name: 'french polynesia'
    },
    {
      code: 'tf',
      name: 'french southern territories'
    },
    {
      code: 'ga',
      name: 'gabon'
    },
    {
      code: 'gm',
      name: 'gambia'
    },
    {
      code: 'ge',
      name: 'georgia'
    },
    {
      code: 'de',
      name: 'germany'
    },
    {
      code: 'gh',
      name: 'ghana'
    },
    {
      code: 'gi',
      name: 'gibraltar'
    },
    {
      code: 'gr',
      name: 'greece'
    },
    {
      code: 'gl',
      name: 'greenland'
    },
    {
      code: 'gd',
      name: 'grenada'
    },
    {
      code: 'gp',
      name: 'guadeloupe'
    },
    {
      code: 'gu',
      name: 'guam'
    },
    {
      code: 'gt',
      name: 'guatemala'
    },
    {
      code: 'gg',
      name: 'guernsey'
    },
    {
      code: 'gn',
      name: 'guinea'
    },
    {
      code: 'gw',
      name: 'guinea-bissau'
    },
    {
      code: 'gy',
      name: 'guyana'
    },
    {
      code: 'ht',
      name: 'haiti'
    },
    {
      code: 'hm',
      name: 'heard island and mcdonald islands'
    },
    {
      code: 'va',
      name: 'holy see (vatican city state)'
    },
    {
      code: 'hn',
      name: 'honduras'
    },
    {
      code: 'hk',
      name: 'hong kong'
    },
    {
      code: 'hu',
      name: 'hungary'
    },
    {
      code: 'is',
      name: 'iceland'
    },
    {
      code: 'in',
      name: 'india'
    },
    {
      code: 'id',
      name: 'indonesia'
    },
    {
      code: 'ir',
      name: 'iran, islamic republic of'
    },
    {
      code: 'iq',
      name: 'iraq'
    },
    {
      code: 'ie',
      name: 'ireland'
    },
    {
      code: 'im',
      name: 'isle of man'
    },
    {
      code: 'il',
      name: 'israel'
    },
    {
      code: 'it',
      name: 'italy'
    },
    {
      code: 'jm',
      name: 'jamaica'
    },
    {
      code: 'jp',
      name: 'japan'
    },
    {
      code: 'je',
      name: 'jersey'
    },
    {
      code: 'jo',
      name: 'jordan'
    },
    {
      code: 'kz',
      name: 'kazakhstan'
    },
    {
      code: 'ke',
      name: 'kenya'
    },
    {
      code: 'ki',
      name: 'kiribati'
    },
    {
      code: 'kp',
      name: "korea, democratic people's republic of"
    },
    {
      code: 'kr',
      name: 'korea, republic of'
    },
    {
      code: 'xk',
      name: 'kosovo'
    },
    {
      code: 'kw',
      name: 'kuwait'
    },
    {
      code: 'kg',
      name: 'kyrgyzstan'
    },
    {
      code: 'la',
      name: "laos (lao people's democratic republic)"
    },
    {
      code: 'lv',
      name: 'latvia'
    },
    {
      code: 'lb',
      name: 'lebanon'
    },
    {
      code: 'ls',
      name: 'lesotho'
    },
    {
      code: 'lr',
      name: 'liberia'
    },
    {
      code: 'ly',
      name: 'libya'
    },
    {
      code: 'li',
      name: 'liechtenstein'
    },
    {
      code: 'lt',
      name: 'lithuania'
    },
    {
      code: 'lu',
      name: 'luxembourg'
    },
    {
      code: 'mo',
      name: 'macao'
    },
    {
      code: 'mg',
      name: 'madagascar'
    },
    {
      code: 'mw',
      name: 'malawi'
    },
    {
      code: 'my',
      name: 'malaysia'
    },
    {
      code: 'mv',
      name: 'maldives'
    },
    {
      code: 'ml',
      name: 'mali'
    },
    {
      code: 'mt',
      name: 'malta'
    },
    {
      code: 'mh',
      name: 'marshall islands'
    },
    {
      code: 'mq',
      name: 'martinique'
    },
    {
      code: 'mr',
      name: 'mauritania'
    },
    {
      code: 'mu',
      name: 'mauritius'
    },
    {
      code: 'yt',
      name: 'mayotte'
    },
    {
      code: 'mx',
      name: 'mexico'
    },
    {
      code: 'fm',
      name: 'micronesia, federated states of'
    },
    {
      code: 'md',
      name: 'moldova, republic of'
    },
    {
      code: 'mc',
      name: 'monaco'
    },
    {
      code: 'mn',
      name: 'mongolia'
    },
    {
      code: 'me',
      name: 'montenegro'
    },
    {
      code: 'ms',
      name: 'montserrat'
    },
    {
      code: 'ma',
      name: 'morocco'
    },
    {
      code: 'mz',
      name: 'mozambique'
    },
    {
      code: 'mm',
      name: 'myanmar'
    },
    {
      code: 'na',
      name: 'namibia'
    },
    {
      code: 'nr',
      name: 'nauru'
    },
    {
      code: 'np',
      name: 'nepal'
    },
    {
      code: 'nl',
      name: 'netherlands'
    },
    {
      code: 'nc',
      name: 'new caledonia'
    },
    {
      code: 'nz',
      name: 'new zealand'
    },
    {
      code: 'ni',
      name: 'nicaragua'
    },
    {
      code: 'ne',
      name: 'niger'
    },
    {
      code: 'ng',
      name: 'nigeria'
    },
    {
      code: 'nu',
      name: 'niue'
    },
    {
      code: 'nf',
      name: 'norfolk island'
    },
    {
      code: 'mk',
      name: 'north macedonia'
    },
    {
      code: 'gb-nir',
      name: 'northern ireland'
    },
    {
      code: 'mp',
      name: 'northern mariana islands'
    },
    {
      code: 'no',
      name: 'norway'
    },
    {
      code: 'om',
      name: 'oman'
    },
    {
      code: 'pk',
      name: 'pakistan'
    },
    {
      code: 'pw',
      name: 'palau'
    },
    {
      code: 'ps',
      name: 'palestine'
    },
    {
      code: 'pa',
      name: 'panama'
    },
    {
      code: 'pg',
      name: 'papua new guinea'
    },
    {
      code: 'py',
      name: 'paraguay'
    },
    {
      code: 'pe',
      name: 'peru'
    },
    {
      code: 'ph',
      name: 'philippines'
    },
    {
      code: 'pn',
      name: 'pitcairn'
    },
    {
      code: 'pl',
      name: 'poland'
    },
    {
      code: 'pt',
      name: 'portugal'
    },
    {
      code: 'pr',
      name: 'puerto rico'
    },
    {
      code: 'qa',
      name: 'qatar'
    },
    {
      code: 'cg',
      name: 'republic of the congo'
    },
    {
      code: 'ro',
      name: 'romania'
    },
    {
      code: 'ru',
      name: 'russian federation'
    },
    {
      code: 'rw',
      name: 'rwanda'
    },
    {
      code: 're',
      name: 'réunion'
    },
    {
      code: 'bl',
      name: 'saint barthélemy'
    },
    {
      code: 'sh',
      name: 'saint helena, ascension and tristan da cunha'
    },
    {
      code: 'kn',
      name: 'saint kitts and nevis'
    },
    {
      code: 'lc',
      name: 'saint lucia'
    },
    {
      code: 'mf',
      name: 'saint martin'
    },
    {
      code: 'pm',
      name: 'saint pierre and miquelon'
    },
    {
      code: 'vc',
      name: 'saint vincent and the grenadines'
    },
    {
      code: 'ws',
      name: 'samoa'
    },
    {
      code: 'sm',
      name: 'san marino'
    },
    {
      code: 'st',
      name: 'sao tome and principe'
    },
    {
      code: 'sa',
      name: 'saudi arabia'
    },
    {
      code: 'gb-sct',
      name: 'scotland'
    },
    {
      code: 'sn',
      name: 'senegal'
    },
    {
      code: 'rs',
      name: 'serbia'
    },
    {
      code: 'sc',
      name: 'seychelles'
    },
    {
      code: 'sl',
      name: 'sierra leone'
    },
    {
      code: 'sg',
      name: 'singapore'
    },
    {
      code: 'sx',
      name: 'sint maarten (dutch part)'
    },
    {
      code: 'sk',
      name: 'slovakia'
    },
    {
      code: 'si',
      name: 'slovenia'
    },
    {
      code: 'sb',
      name: 'solomon islands'
    },
    {
      code: 'so',
      name: 'somalia'
    },
    {
      code: 'za',
      name: 'south africa'
    },
    {
      code: 'gs',
      name: 'south georgia and the south sandwich islands'
    },
    {
      code: 'ss',
      name: 'south sudan'
    },
    {
      code: 'es',
      name: 'spain'
    },
    {
      code: 'lk',
      name: 'sri lanka'
    },
    {
      code: 'sd',
      name: 'sudan'
    },
    {
      code: 'sr',
      name: 'suriname'
    },
    {
      code: 'sj',
      name: 'svalbard and jan mayen islands'
    },
    {
      code: 'sz',
      name: 'swaziland'
    },
    {
      code: 'se',
      name: 'sweden'
    },
    {
      code: 'ch',
      name: 'switzerland'
    },
    {
      code: 'sy',
      name: 'syrian arab republic'
    },
    {
      code: 'tw',
      name: 'taiwan (republic of china)'
    },
    {
      code: 'tj',
      name: 'tajikistan'
    },
    {
      code: 'tz',
      name: 'tanzania, united republic of'
    },
    {
      code: 'th',
      name: 'thailand'
    },
    {
      code: 'tl',
      name: 'timor-leste'
    },
    {
      code: 'tg',
      name: 'togo'
    },
    {
      code: 'tk',
      name: 'tokelau'
    },
    {
      code: 'to',
      name: 'tonga'
    },
    {
      code: 'tt',
      name: 'trinidad and tobago'
    },
    {
      code: 'tn',
      name: 'tunisia'
    },
    {
      code: 'tr',
      name: 'turkey'
    },
    {
      code: 'tm',
      name: 'turkmenistan'
    },
    {
      code: 'tc',
      name: 'turks and caicos islands'
    },
    {
      code: 'tv',
      name: 'tuvalu'
    },
    {
      code: 'ug',
      name: 'uganda'
    },
    {
      code: 'ua',
      name: 'ukraine'
    },
    {
      code: 'ae',
      name: 'united arab emirates'
    },
    {
      code: 'gb',
      name: 'united kingdom'
    },
    {
      code: 'us',
      name: 'united states'
    },
    {
      code: 'uy',
      name: 'uruguay'
    },
    {
      code: 'um',
      name: 'us minor outlying islands'
    },
    {
      code: 'uz',
      name: 'uzbekistan'
    },
    {
      code: 'vu',
      name: 'vanuatu'
    },
    {
      code: 've',
      name: 'venezuela, bolivarian republic of'
    },
    {
      code: 'vn',
      name: 'vietnam'
    },
    {
      code: 'vg',
      name: 'virgin islands, british'
    },
    {
      code: 'vi',
      name: 'virgin islands, u.s.'
    },
    {
      code: 'gb-wls',
      name: 'wales'
    },
    {
      code: 'wf',
      name: 'wallis and futuna islands'
    },
    {
      code: 'eh',
      name: 'western sahara'
    },
    {
      code: 'ye',
      name: 'yemen'
    },
    {
      code: 'zm',
      name: 'zambia'
    },
    {
      code: 'zw',
      name: 'zimbabwe'
    },
    {
      code: 'ax',
      name: 'Åland islands'
    }
  ]
}
